"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OffChainStorage = void 0;
const __1 = require("../..");
const ScoreStorage_1 = require("./ScoreStorage");
class OffChainStorage extends ScoreStorage_1.ScoreStorage {
    constructor(logger, titanScoresDb, cache) {
        super(logger);
        this.logger = logger;
        this.titanScoresDb = titanScoresDb;
        this.cache = cache;
        this.MANIFEST_COLLECTION = '_manifests';
        this.BLOCKCHAIN_COLLECTION = '_blockchains';
    }
    readScores(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const collection = this.titanScoresDb[(0, __1.getNetworkGroup)(params.chainId)].collection(params.protocol);
            return this.getScores(collection, params);
        });
    }
    readScoresCount(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const cacheKey = `${params.chainId}_${params.protocol}_${JSON.stringify(params.accounts)}_offchain_scores_count`;
            const cachedCount = this.cache.get(cacheKey);
            if (cachedCount) {
                return cachedCount;
            }
            const collection = this.titanScoresDb[(0, __1.getNetworkGroup)(params.chainId)].collection(params.protocol);
            const count = this.getScoreCount(collection, params);
            this.cache.set(cacheKey, count);
            return count;
        });
    }
    readManifest(chainId, name) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const collection = this.titanScoresDb[(0, __1.getNetworkGroup)(chainId)].collection(this.MANIFEST_COLLECTION);
                const manifest = (yield collection.findOne({ name }));
                return manifest;
            }
            catch (error) {
                this.logger.error(`TitanStorage::readManifest => ${name}:${error}`);
            }
        });
    }
    updateManifest(chainId, name, manifest) {
        return __awaiter(this, void 0, void 0, function* () {
            delete manifest._id; // Must strip _id so that it won't clash with the id of the document to replace
            try {
                const collection = this.titanScoresDb[(0, __1.getNetworkGroup)(chainId)].collection(this.MANIFEST_COLLECTION);
                const updatedManifest = yield collection.updateOne({ name }, { $set: manifest });
                return updatedManifest.acknowledged;
            }
            catch (error) {
                this.logger.error(`TitanStorage::updateManifest => ${name}:${error}`);
                return false;
            }
        });
    }
    readAllManifests(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const collection = this.titanScoresDb[(0, __1.getNetworkGroup)(chainId)].collection(this.MANIFEST_COLLECTION);
                const manifests = (yield collection
                    .find()
                    .project(this.getManifestProjection())
                    .toArray());
                return manifests;
            }
            catch (error) {
                this.logger.error(`TitanStorage::readManifests => ${error}`);
                return [];
            }
        });
    }
    readBlockchains(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const collection = this.titanScoresDb[(0, __1.getNetworkGroup)(chainId)].collection(this.BLOCKCHAIN_COLLECTION);
                const blockchains = (yield collection.find().toArray());
                return blockchains;
            }
            catch (error) {
                this.logger.error(`OffChainStorage::readBlockchains => ${error}`);
                return [];
            }
        });
    }
    getManifestProjection() {
        return {
            _id: 0,
        };
    }
}
exports.OffChainStorage = OffChainStorage;
//# sourceMappingURL=OffChainStorage.js.map